/* eslint-disable max-len */
import React,{ useState, useEffect } from 'react'
import { distributorService } from '../../../service/distributor.service'

const VirtualPaymentModal = ({virtualPaymentModal, setVirtualPaymentModal}) => {
    const [distributorDetails,setdistributorDetails] = useState(null)

    const getVirtualPaymentDetails = async() => {
        const res = await distributorService.Getprofile();
        if (!res.error && res.data.success_status) {
            setdistributorDetails(res?.data?.data);
        }
    }
    useEffect(()=>{
        getVirtualPaymentDetails()
    },[])

    return (
        <>
            <div className={`modal fade ${virtualPaymentModal ? 'show' : 'hidden'} fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="virtualPayment" tabIndex="-1" aria-labelledby="virtualPayment" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered relative lg:max-w-[443px] lg:min-w-[443px] w-full px-3 mx-auto pointer-events-none" style={{ margin: 'auto'}}>
                    <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white bg-clip-padding rounded-md outline-none text-current sm:pt-11 pt-8 pb-6 sm:px-[30px] px-6">
                        <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                            <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406] flex items-center justify-center w-full" id="exampleModalScrollableLabel">
                                Virtual Payment Instructions
                            </h5>
                        </div>
                        <button onClick={() => setVirtualPaymentModal(false)} type="button" className="absolute sm:top-4 sm:right-4 top-2.5 right-2.5" data-bs-dismiss="modal" aria-label="Close">
                            <img src="/images/Icon-ionic-ios-close.svg" alt="icon"/>
                        </button>
                        <div className="sm:pt-8 pt-6 pl-4">
                            <ol className="list-decimal">
                                <li className="text-sm font-normal text-[#090406]">
                                    Please Login to your internet banking portal or open your bank’s mobile app
                                </li>
                                <li className="text-sm font-normal text-[#090406] mt-2">
                                    Add your virtual account details ( for the first transfer) along with the IFSC code as Beneficiary.
                                </li>
                                <li className="text-sm font-normal text-[#090406] mt-2">
                                    Note your <span className="font-semibold">Virtual Account Number:</span> {distributorDetails?.virtual_account_info?.receivers[0]?.account_number}, <span className="font-semibold">IFSC Code:</span> {distributorDetails?.virtual_account_info?.receivers[0]?.ifsc}
                                </li>
                                <li className="text-sm font-normal text-[#090406] mt-2">
                                    Input the amount you wanted to transfer and initiate the transfer using IMPS / NEFT or RTGS
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div></>
    )
}

export default VirtualPaymentModal